import { preloadImages } from '@10000/react'
import { assetUrl } from '../../../utilities.js'

export const preload = async () => {
  await preloadImages(
    assetUrl(`gifs/eye-opening.gif`)
  )
}